/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 10:26:49
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-23 15:30:14
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/slice/edit.ts
 */
import { defaultData } from '../tool';
import { clearError } from 'src/tools/helper';
import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { getParameter, nameCopy } from '@/src/tools/helper';
import { getCollectionDetail } from '@/src/request/salesChannel/collection';
import { get } from 'lodash';

export const fetchCollectionDetail = createAsyncThunk(
  'fetchCollectionDetail',
  async ({ uuid, list, params }: any) => {
    const response = await getCollectionDetail(uuid, params);
    return { response, collectionList: list };
  },
);

//TODO:Filter单选和多选的问题
const salesChannelCollectionEditSlice = createSlice({
  name: 'salesChannelCollectionEdit',
  initialState: defaultData,
  reducers: {
    setName(state, action) {
      state.collectionName = action.payload;
      state.collectionNameError = (
        clearError({
          name: action.payload,
        }) as any
      ).collectionNameError;
      state.hasModified = true;
    },
    setNameError(state, action) {
      state.collectionNameError = action.payload;
    },
    setSEOSetting(state, action) {
      //console.log('action.payload', action.payload);
      state.seoSetting = { ...state.seoSetting, ...clearError(action.payload) };
      const keys = Object.keys(state.seoSetting);
      if (keys.includes('urlSlug')) {
        console.log('keys', keys);
        state.hasModified = true;
      }
      if (keys.includes('urlSlug') && keys.includes('slugValid')) {
        if (
          get(state, 'seoSetting.urlSlug') === get(action.payload, 'urlSlug')
        ) {
        } else {
          state.hasModified = true;
        }
      } else if (!keys.includes('urlSlug') && keys.includes('slugValid')) {
        state.hasModified = true;
      } else {
        state.hasModified = true;
      }
    },
    setFeaturedImage(state, action) {
      state.featuredImage = action.payload;
      state.hasModified = true;
    },
    setProductsUuid(state, action) {
      state.salesChannelProductUuids = action.payload;
      state.hasModified = true;
    },
    setProducts(state, action) {
      state.products = action.payload;
      const uuidList = action.payload.map((product) => product.uuid);
      state.salesChannelProductUuids = uuidList;
      state.hasModified = true;
    },
    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },
    onLanguageChange(state, action) {
      state.hasModified = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCollectionDetail.fulfilled, (state, action: any) => {
      state.loaded = true;
      const { collectionName, featuredImage, products, seoSetting } =
        action.payload.response;
      state.collectionName =
        getParameter('type') == 'Duplicate'
          ? nameCopy(collectionName, action.payload.collectionList)
          : collectionName;
      state.featuredImage = featuredImage;
      const uuidList = products.map((product) => product.uuid);
      state.salesChannelProductUuids = uuidList;
      state.products = products;
      state.seoSetting = seoSetting;
      state.hasModified = false;
    });
  },
});
const getCollapseStatus = (id) => {
  return createSelector(
    [(state: any) => state.salesChannelCollectionEdit.collapseOpen[id]],
    (status) => {
      return status;
    },
  );
};

export const getCollapse = (id) => {
  return getCollapseStatus(id);
};

export const {
  setName,
  setNameError,
  setSEOSetting,
  setFeaturedImage,
  setProducts,
  onCollapseChange,
  onLanguageChange,
} = salesChannelCollectionEditSlice.actions;

export default salesChannelCollectionEditSlice.reducer;
